<template>
  <div class="cjt-customer" v-show="!hidden">
    <div class="support-sobot-btn" @click="openSobot">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="icon icon-tabler icons-tabler-outline icon-tabler-brand-hipchat"
      >
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <path
          d="M17.802 17.292s.077 -.055 .2 -.149c1.843 -1.425 3 -3.49 3 -5.789c0 -4.286 -4.03 -7.764 -9 -7.764c-4.97 0 -9 3.478 -9 7.764c0 4.288 4.03 7.646 9 7.646c.424 0 1.12 -.028 2.088 -.084c1.262 .82 3.104 1.493 4.716 1.493c.499 0 .734 -.41 .414 -.828c-.486 -.596 -1.156 -1.551 -1.416 -2.29z"
        />
        <path d="M7.5 13.5c2.5 2.5 6.5 2.5 9 0" />
      </svg>
      <div>在线咨询</div>
    </div>
    <div class="divider"></div>
    <div class="phone">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="icon icon-tabler icons-tabler-outline icon-tabler-phone-call"
      >
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <path
          d="M5 4h4l2 5l-2.5 1.5a11 11 0 0 0 5 5l1.5 -2.5l5 2v4a2 2 0 0 1 -2 2a16 16 0 0 1 -15 -15a2 2 0 0 1 2 -2"
        />
        <path d="M15 7a2 2 0 0 1 2 2" />
        <path d="M15 3a6 6 0 0 1 6 6" />
      </svg>
      <div class="">电话热线</div>
      <div class="phone-pop">
        <div class="phone-list">
          4008热线: 4001828088
          <div class="arrow" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      hidden: false,
      openSobot: () => {
        window.open(
          'https://cjt.sobot.com/chat/pc/v6/index.html?sysnum=05065519e3bb446bbe9f6d41f3ce53e8&channelid=4&full=1',
          '',
          `width=795,height=665,top=${(window.screen.height - 775) / 2},left=${(window.screen.width - 795) / 2}`
        );
      },
    };
  },
  methods: {
    close() {
      this.hidden = true;
    },
  },
};
</script>
<style scoped lang="less">
.cjt-customer {
  position: fixed;
  bottom: 100px;
  right: 0;
  z-index: 2;
  background-color: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  padding: 10px 5px;
  font-size: 12px;
  color: #999;

  svg {
    margin: 0 auto 5px;
    display: block;
  }

  > div:hover {
    color: #1643d4;
  }

  .divider {
    height: 1px;
    background: #e8e8e8;
    margin: 10px 0;
  }

  .support-sobot-btn {
    cursor: pointer;

    img {
      height: 86px;
      width: 86px;
    }

    .text {
      background: linear-gradient(#00a0ea, #1643d4);
      position: relative;
      margin-left: 2px;
      margin-top: -10px;
      width: 82px;
      border-radius: 4px;
      text-align: center;
      font-size: 14px;
      line-height: 28px;
      color: #fff;
    }
  }

  .phone {
    position: relative;

    .phone-icon {
      width: 32px;
      height: 32px;
    }

    &:hover .phone-pop {
      display: block;
    }

    .phone-pop {
      position: absolute;
      right: 100%;
      top: -6px;
      display: none;
      padding-right: 24px;
      filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));

      .phone-list {
        position: relative;
        white-space: nowrap;
        background: #fff;
        padding: 16px;
        font-size: 16px;
        color: #333;

        .arrow {
          position: absolute;
          left: 100%;
          top: 22px;
          border: 5px solid transparent;
          border-left: 6px solid #fff;
        }
      }
    }
  }

  .btn-close {
    background: none;
    outline: none;
    border: none;
    width: 20px;
    height: 20px;
    position: absolute;
    top: -10px;
    left: -10px;
    cursor: pointer;
    background: white;
    border-radius: 100%;
    overflow: hidden;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/SideService.vue